import { 
  printReceiptQR,
  printReceiptBT, 
  printReceiptSerial
} from './printCommands'
import {
  micraJotaSale
} from './micraJotaModel'

const micraJotaDriver = {
  printReceipt: {
    MicraJotaBarcode: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptQR(fiscalReceipt, printSlip, micraJotaSale, deviceParams, sendMessageToWebView)
    },
    MicraJotaBT: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptBT(fiscalReceipt, printSlip, micraJotaSale, deviceParams, sendMessageToWebView)
    },
    MicraJotaSerial: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptSerial(fiscalReceipt, printSlip, micraJotaSale, { ...deviceParams, parity: 'even' }, sendMessageToWebView)
    }
  }
}

export {
  micraJotaDriver
}